
import { defineComponent } from "vue";
import SiteWrapper from "@/components/SiteWrapper.vue";

export default defineComponent({
  name: "App",

  components: {
    SiteWrapper,
  },
});

//TODO: game over screen rework
